module.exports = __webpack_public_path__ + "static/media/share-alt.8929ba43.svg";